import { Link } from 'react-router-dom';
import { getIsMobile } from '../../../utils/getIsMobile';
import { useTranslation } from '../../../utils/useTranslation';
import { Box } from '../../layout/Box';
import { Typography } from '../../typography/Typography';
import { DISTRIBUTION_AGREEMENT_URL, USER_AGREEMENT_URL } from './constants';

export const CpaTrialDisclaimer = () => {
    const t = useTranslation();
    const isMobile = getIsMobile().isMobile;
    const textVariant = isMobile ? 'caption2' : 'caption';

    return (
        <Box pt={2} pb={isMobile ? 2 : 0}>
            <Typography variant={textVariant} color="secondary" textAlign="left">
                {t('Продолжая, вы принимаете наше ')}
                <Typography
                    as={Link}
                    variant={textVariant}
                    color="link"
                    to={USER_AGREEMENT_URL}
                    target="_blank"
                    display="inline"
                    style={{ textDecoration: 'none' }}
                >
                    {t('Пользовательское соглашение')}
                </Typography>
                {t(' и ')}
                <Typography
                    as={Link}
                    variant={textVariant}
                    color="link"
                    to={DISTRIBUTION_AGREEMENT_URL}
                    target="_blank"
                    display="inline"
                    style={{ textDecoration: 'none' }}
                >
                    {t('Соглашение о порядке распространения продуктов Яндекса в тестовом режиме')}
                </Typography>
                {t(
                    ' и подтверждаете создание для вас уникальных идентификаторов пакета дистрибуции «Внешние товарные предложения для Яндекс Ритма».',
                )}
            </Typography>
        </Box>
    );
};
